import { inject, Pipe, PipeTransform } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { IBlockForm } from '../models/blocks/block-form.interface';
import { SurveyEditorService } from '../services/survey-editor.service';

@Pipe({
  name: 'block',
  pure: true
})
export class BlockPipe implements PipeTransform {
  private surveyEditorService = inject(SurveyEditorService);

  transform(bId: string): FormGroup<IBlockForm> {
    return this.surveyEditorService.surveyEditor$().blocks.all.controls.find((b) => b.value.id === bId);
  }
}
